export default __webpack_public_path__ + "static/media/3_retalho.58971f6b.webp";